const FairplayLogo = 'theme/Fairplaylive/title.png';
const FairplayIcon = 'theme/Fairplaylive/favicon.png';
const PlayaddaLogo = 'theme/Playaddacom/title.png';
const PlayaddaIcon = 'theme/Playaddacom/favicon.png';
const PinkybetCoLogo = 'theme/Pinkybetco/title.png';
const PinkybetCoIcon = 'theme/Pinkybetco/favicon.png';
const VardaanLogo = 'theme/Vardaanvip/title.png';
const VardaanIcon = 'theme/Vardaanvip/favicon.png';

const faiplayLiveEnvs = {
  FOLDER_NAME: 'Fairplaylive',
  BRAND_NAME: 'Fairplay',
  BRAND_DOMAIN: 'fairplay.live',
  logo: FairplayLogo,
  favicon: FairplayIcon,
};
const playAddaEnvs = {
  FOLDER_NAME: 'Playaddacom',
  BRAND_NAME: 'Playadda',
  BRAND_DOMAIN: 'playadda.com',
  logo: PlayaddaLogo,
  favicon: PlayaddaIcon,
};
const pinkybetCoEnvs = {
  FOLDER_NAME: 'Pinkybetco',
  BRAND_NAME: 'Pinkybet',
  BRAND_DOMAIN: 'pinkybet.co',
  logo: PinkybetCoLogo,
  favicon: PinkybetCoIcon,
};

const stagePinkybetCoEnvs = {
  FOLDER_NAME: 'Pinkybetco',
  BRAND_NAME: 'Pinkybet',
  BRAND_DOMAIN: 'wl1.quickexch.com',
  logo: PinkybetCoLogo,
  favicon: PinkybetCoIcon,
};
const PinkybetpkEnvs = {
  FOLDER_NAME: 'Pinkybetpk',
  BRAND_NAME: 'Pinkybetpk',
  BRAND_DOMAIN: 'pinkybet.pk',
  logo: PinkybetCoLogo,
  favicon: PinkybetCoIcon,
};
const vardaanVipEnvs = {
  FOLDER_NAME: 'Vardaanvip',
  BRAND_NAME: 'Vardaan',
  BRAND_DOMAIN: 'vardaan.vip',
  logo: VardaanLogo,
  favicon: VardaanIcon,
};
export const WhitelabelEnvMap = {
  localhost: stagePinkybetCoEnvs,

  'wl1.quickexch.com': stagePinkybetCoEnvs,

  // Stage domains
  'stage.ultrawin.games': pinkybetCoEnvs,
  'stage.playadda.com': playAddaEnvs,
  'stage.fairplay.live': faiplayLiveEnvs,
  'stage.vardaan.vip': vardaanVipEnvs,

  // Prod domains
  'pinkybet.co': pinkybetCoEnvs,
  'pinkybet.pk': PinkybetpkEnvs,
  'pinkybet.vip': pinkybetCoEnvs,
  'pinkybet.win': pinkybetCoEnvs,
};

export function getEnvVariable(domain: string, variable: string) {
  return WhitelabelEnvMap[domain.replace(/www./g, '')][variable];
}
